import { useIntl } from "react-intl";
import { useCreateCheckoutSession } from "~/api/billing/billing";
import { OrganizationRole } from "~/api/model/organizationRole";
import walletIcon from "~/assets/wallet.png";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";
import { Button } from "~/components/ui/button";
import { DisplayFor } from "./permissions/DisplayFor";

interface PaymentFailedModalProps {
  open: boolean;
  organizationId: string;
}

export const PaymentFailedModal = ({
  open,
  organizationId,
}: PaymentFailedModalProps) => {
  const { formatMessage } = useIntl();
  const { mutate: createCheckoutSession, isPending } =
    useCreateCheckoutSession();

  const handlePaymentClick = () => {
    createCheckoutSession(
      { organizationId, data: {} },
      {
        onSuccess: (data) => {
          if (data.checkoutUrl) {
            window.open(data.checkoutUrl, "_blank");
          }
        },
      }
    );
  };

  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="w-[608px] justify-center px-6 py-10">
        <AlertDialogHeader className="flex flex-col items-center">
          <img src={walletIcon} alt="Wallet" className="h-14 w-14 mt-4" />
          <AlertDialogTitle className="text-lg font-semibold text-base-foreground">
            {formatMessage({
              id: "paymentFailed.title",
              defaultMessage: "Subscription Paused",
            })}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-muted-foreground text-sm text-center">
            {formatMessage({
              id: "paymentFailed.description",
              defaultMessage:
                "There's a problem with your payment method, and your subscription is on hold due to a balance due.",
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex flex-col justify-center sm:justify-center">
          <DisplayFor
            roles={[OrganizationRole.OWNER, OrganizationRole.SUPERADMIN]}
          >
            <Button onClick={handlePaymentClick} disabled={isPending}>
              {formatMessage({
                id: "paymentFailed.update",
                defaultMessage: "Update Billing",
              })}
            </Button>
          </DisplayFor>
          <DisplayFor roles={[OrganizationRole.MEMBER, OrganizationRole.GUEST]}>
            <p className="text-sm text-muted-foreground">
              {formatMessage({
                id: "paymentFailed.text",
                defaultMessage:
                  "Please ask your account administrator to update the billing details.",
              })}
            </p>
          </DisplayFor>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
